import { FETCH_POSTS_FEED_DATA } from "../actions/postsFeedAction";
import { isFulfilled, isPending } from "./reducerUtils";

const postsFeedReducer = (
    state = {
        postsFeedData: null,
        postFeedDataLoading: false
    },
    action
) => {
    switch (action.type) {
        case FETCH_POSTS_FEED_DATA:
            return { ...state, postsFeedData: action.payload, postFeedDataLoading: false };
        case isPending(FETCH_POSTS_FEED_DATA):
            return { ...state, postsFeedData: null, postFeedDataLoading: true };
        case isFulfilled(FETCH_POSTS_FEED_DATA):
            return { ...state, postsFeedData: action.payload.hits.hits, postFeedDataLoading: false };
        default:
            return state;
    }
};

export default postsFeedReducer;
